module.exports = __webpack_public_path__ + "static/media/Meditation Music Zone - Успокойся.efa2e2b9.mp3";